const getBaselayer = () => ({
    session_id: window.__global_base_session_id,
    instance_id: window.__global_base_instance_id,
    device_id: window.__global_base_device_id,
    session_count: window.__global_base_session_count
});

export default getBaselayer;
